import "../../../css/buttons/PrimaryButton.css";

const BOOKING_URL =
  "https://bookings.cloud.microsoft/bookwithme/user/fa2261725ab84f21bb747357792d358b%40akmortgages.uk?anonymous&ismsaljsauthenabled";

const scrollToContact = () => {
  document
    .getElementById("contact-us")
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
};

const PrimaryButton = ({ onClick, text }) => {
  const handleClick =
    onClick ||
    (() => {
      const label = text?.toLowerCase() || "";

      if (label.includes("book a free initial appointment")) {
        window.open(BOOKING_URL, "_blank");
        return;
      }

      if (label.includes("contact us")) {
        scrollToContact();
      }
    });

  return (
    <button type="button" className="primary-button" onClick={handleClick}>
      <div className="button-text">{text}</div>
    </button>
  );
};

export default PrimaryButton;
